import type { AxiosResponse } from "axios";
import { codeSuccess } from "@shared/types/enums/AxiosEnum";

export class HttpResponse<TData = any> {
  // readonly error?: boolean;
  // readonly errorCode: string;
  data: TData;
  readonly message: string;
  readonly status: number;

  constructor(response?: AxiosResponse, entityClass?: any, status?: number) {
    this.data = response?.data
      ? entityClass
        ? new entityClass(response.data)
        : response.data
      : entityClass
      ? new entityClass()
      : response?.data;
    this.message = response?.data?.message || response?.data?.error?.error_message || "";
    this.status = status ?? response?.status ?? 0;
    // this.errorCode = response?.data?.code || response?.data?.error?.error_code || "";
    // this.error = error ?? !codeSuccess.includes(Number(response?.status) || 0);
  }
}

export class SearchResponse<TData> {
  data: TData[] = [];
  readonly status: number = 0;
  readonly errorCode: string;
  readonly errorMsg: string;
  readonly error?: boolean;
  readonly nextLink: string;
  readonly total: number;

  constructor(response?: AxiosResponse, entityClass?: any, key?: string) {
    if (key) {
      this.data =
        response?.data && response.data[key]
          ? entityClass
            ? (response.data[key] || []).map((item: any) => new entityClass(item))
            : response.data[key]
          : [];
    } else {
      this.data = response?.data?.length
        ? entityClass
          ? response.data.map((item: any) => new entityClass(item))
          : response.data
        : [];
    }
    this.status = response?.status || 0;
    this.errorCode = response?.data?.code || response?.data?.error?.code || "";
    this.errorMsg = response?.data?.message || response?.data?.error?.message || "";
    this.error = !codeSuccess.includes(Number(response?.status) || 0);
    this.nextLink = response?.data && response?.data?.nextPageToken ? response.data?.nextPageToken : "";
    this.total = response?.data && response?.data["@odata.count"] ? response.data["@odata.count"] : 0;
  }
}
